var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInactiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74395 23.6163C10.2516 24.2583 10.8985 24.7765 11.6358 25.1318C12.3731 25.4871 13.1815 25.6702 13.9999 25.6673C14.8184 25.6702 15.6268 25.4871 16.3641 25.1318C17.1014 24.7765 17.7483 24.2583 18.2559 23.6163C15.4315 23.9992 12.5684 23.9992 9.74395 23.6163ZM21.875 10.5007V11.322C21.875 12.3078 22.1549 13.2715 22.6823 14.0917L23.9749 16.1018C25.1544 17.9382 24.2538 20.4337 22.2016 21.0135C16.8393 22.5324 11.1606 22.5324 5.79828 21.0135C3.74612 20.4337 2.84545 17.9382 4.02495 16.1018L5.31762 14.0917C5.84679 13.2649 6.12741 12.3036 6.12612 11.322V10.5007C6.12612 5.99032 9.65178 2.33398 13.9999 2.33398C18.3481 2.33398 21.875 5.99032 21.875 10.5007Z",
    fill: "#070707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInactiveIcon);
export default __webpack_public_path__ + "static/media/notificationInactiveIcon.60af429a7d1a3b52c4bfcffb7196eba1.svg";
export { ForwardRef as ReactComponent };